import React, { useEffect, useState } from "react"
import {
  Col,
  Button,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
} from "reactstrap"

import { withRouter } from "react-router-dom"
import { map } from "lodash"

//Import Cards
import CardGrid from "./CardGrid"
import CarParkCreate from "./CarParkCreate"

import { getCarParks as onGetCarParks } from "../../store/carpark/actions"

//redux
import { useSelector, useDispatch } from "react-redux"

const CarParkList = props => {
  const dispatch = useDispatch()
  const [selectedCarpark, setSelectedCarpark] = useState({})
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const { carParks, pagination } = useSelector(state => ({
    carParks: state.carPark.carParkList,
    pagination: state.carPark.pagination,
  }))

  const [page, setPage] = useState(pagination?.currentPage || 1)

  useEffect(() => {
    // dispatch(onGetCarParks({ page: page, size: 75 }))
    dispatch(onGetCarParks({}))
  }, [dispatch])

  const handlePageClick = page => {
    setPage(page)
    dispatch(onGetCarParks({ page: page, size: 75 }))
  }

  const handleCarparkClick = e => {
    toggle()
    setSelectedCarpark(null)
  }

  const toggle = () => {
    setModal(!modal)
  }

  return (
    <React.Fragment>
      <Row className="mb-2">
        <Col sm="4"></Col>
        <Col sm="8">
          <div className="text-sm-end">
            <Button type="submit" color="primary" onClick={handleCarparkClick}>
              <i className="mdi mdi-plus-circle-outline me-1" />
              Add New Carpark
            </Button>
          </div>
        </Col>
      </Row>
      <Row>
        <CardGrid
          data={carParks || []}
          openEdit={obj => {
            setSelectedCarpark(obj)
            setIsEdit(true)
            toggle()
          }}
        />
      </Row>
      <CarParkCreate
        modal={modal}
        toggle={() => {
          setSelectedCarpark(null)
          setIsEdit(false)
          toggle()
        }}
        selectedCarpark={selectedCarpark}
        isEdit={isEdit}
        setSelectedCarpark={setSelectedCarpark}
        setIsEdit={setIsEdit}
      />

      {/* <Row>
        <Col lg="12">
          <Pagination className="pagination pagination-rounded justify-content-end mb-2">
            <PaginationItem disabled={page === 1}>
              <PaginationLink
                previous
                href="#"
                onClick={() => handlePageClick(page - 1)}
              />
            </PaginationItem>
            {map(Array(pagination?.totalPages || 0), (item, i) => (
              <PaginationItem active={i + 1 === page} key={i}>
                <PaginationLink onClick={() => handlePageClick(i + 1)} href="#">
                  {i + 1}
                </PaginationLink>
              </PaginationItem>
            ))}
            <PaginationItem disabled={page === pagination?.totalPages}>
              <PaginationLink
                next
                href="#"
                onClick={() => handlePageClick(page + 1)}
              />
            </PaginationItem>
          </Pagination>
        </Col>
      </Row> */}
    </React.Fragment>
  )
}

export default CarParkList
